import {EventBus} from '@/utils/event-bus'
import axios from 'axios'
import _ from 'lodash'

export default {
  methods: {

    backToProducts() {
      this.$router.push({
        path: '/products'
      })
    },

    async getProductById(id) {
      EventBus.$emit('showLoading', true)
      let vm = this
      try{
        let p = await axios.get(this.getProductApi + '/products/' + id)
        vm.product = p.data
        // add photo object if do not existe
        if (!vm.product.photos) {
          vm.product.photos = [{
            id: null,
            name: null,
            order: 0
          }]
        }
        this.$forceUpdate()
        if (vm.product.ean) {
          vm.getProductByEAN(vm.product.ean)
        } else {
          EventBus.$emit('showLoading', false)
        }
        vm.enablePresentations = vm.product.has_presentation
        this.loadingProduct = false
        return true
     }catch(e) {
      console.log()
      EventBus.$emit('showLoading', false)
      this.loadingProduct = false
     }
    },

    getProductByEAN(ean) {
      let vm = this
      axios.get(this.getProductApi + '/product/' + ean)
        .then((g) => {
          if (g.data) {
            vm.global = g.data
            console.log(g.data)
          }
          EventBus.$emit('showLoading', false)
        })
        .catch((e) => {
          console.log(e)
          EventBus.$emit('showLoading', false)
        })
    },

    getImage() {
      if (this.product.photos && this.product.photos.length && this.product.photos[0].id && this.product.photos[0].id.includes("300x300")) {
        return 'https://cdnimages.opa4.store/productImages/' + this.product.photos[0].id
      } else if (this.product.photos && this.product.photos.length && this.product.photos[0].id) {
        return 'https://cdnimages.opa4.store/productImages/' + this.product.photos[0].id
      } else {
        return null
      }
    },

    async uploadImage(e) {
      let vm = this
      if (e.target.value) {
        let bodyFormData = new FormData()
        // let blob = new Blob(, { type: 'image/png' })
        bodyFormData.append('file', e.target.files[0])
        EventBus.$emit('showLoading', true)
        axios({
          method: 'post',
          url: this.getOpaApi + '/files/company/' + this.getCompany().companyId + '/product',
          data: bodyFormData,
          config: {
            headers: {
              'Content-Type': 'form-data'
            }
          }
        })
          .then(async function (response) {
            //handle success
            if (!vm.product.photos.length) {
              vm.product.photos.push({
                id: '',
                order: 0
              })
            }
            vm.product.photos[0].id = vm.getCompany().companyId + '/' + response.data.file_name
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'imagem atualizada')
            console.log(vm.product.id)
            if (vm.product.id) {
              await vm.saveProduct(false, false)
            }
          })
          .catch(function (response) {
            //handle error
            console.log(response)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao subir imagem')
          })
      }
    },

    async saveProduct(redirect, validateView) {
      let vm = this
      EventBus.$emit('showLoading', true)
      this.product.has_presentation = this.enablePresentations
      this.product.product_views[0].price = Number(this.product.product_views[0].price)
      this.product.product_views[0].promotional_price = Number(this.product.product_views[0].promotional_price)
      this.product.product_views[0].price_cost = Number(this.product.product_views[0].price_cost)
      this.product.product_views[0].stock_quantity = Number(this.product.product_views[0].stock_quantity)
      this.product.product_views[0].name = this.product.name
      this.product.product_views[0].active = this.product.active
      this.product.related_ids = !this.product.related_ids ? [] : this.product.related_ids
      let valid = true
      if (validateView) {
        valid = this.validateProductViews() && this.validateOptions() && this.validateRelatedIds()
      }
      if (valid) {
        if (!this.product.id || this.product.id === '0') {
          console.log(this.product.id)
          try {

            // remove photo object if null
            let prodClone = _.clone(this.product)
            if (prodClone.photos && prodClone.photos.length && !prodClone.photos[0].id) {
              prodClone.photos = []
            }

            let result = await axios.post(this.getProductApi + '/products', prodClone)
            if (result) {
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'success', 'produto salvo com sucesso')
              vm.$router.push({
                path: '/products'
              })
            } else {
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'error', 'erro ao salvar produto')
            }
          } catch (e) {
            console.log(e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao salvar produto')
          }
        } else {
          try {
            let prodClone = _.clone(this.product)
            if (prodClone.photos && prodClone.photos.length && !prodClone.photos[0].id) {
              prodClone.photos = []
            }
            let result = await axios.put(this.getProductApi + '/products', prodClone)
            if (result.data) {
              this.product = result.data
              this.$forceUpdate()
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'success', 'produto salvo com sucesso')
              if (redirect) {
                vm.$router.push({
                  path: '/products'
                })
              }
            } else {
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'error', 'erro ao atualizar produto')
            }
          } catch (e) {
            console.log(e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao salvar produto')
          }
        }
      } else {
        EventBus.$emit('showLoading', false)
      }
    },

    validateRelatedIds(){
      let valid = true
        if (this.product.related_ids.length == 1) {
          EventBus.$emit('showAlert', 'error', 'Campo "Produtos Relacionados" deve ser nenhum ou maior que um produto')
          valid = false
        }
        return valid
    },

    validateProductViews() {
      let valid = this.valdateViewCobination()
      if (!valid) {
        EventBus.$emit('showAlert', 'error', 'Combinação de views duplicada')
        return false
      }
      for (let x = 0; x < this.product.product_views.length; x++) {

        if (!this.product.product_views[x].name || !this.product.product_views[x].name.length) {
          valid = false
          EventBus.$emit('showAlert', 'error', 'Necessário inserir um Nome do Produto')
          break
        }
        if (!this.product.product_views[x].stock_quantity.toString().length) {
          valid = false
          EventBus.$emit('showAlert', 'error', 'Campo estoque é obrigatório')
          break
        }
        if (!this.product.product_views[x].price) {
          valid = false
          EventBus.$emit('showAlert', 'error', 'Campo preço é obrigatório e deve ser maior que 0')
          break
        }
      }
      return valid
    },

    valdateViewCobination() {
      if (this.product.product_views.length > 1) {
        let choiced = []
        let valid = true
        this.product.product_views.forEach((pv) => {
          let choice = pv.view.map((c) => c.presentation_id + '|' + c.option_id + '|')
          choice.sort()
          let choiceStr = choice.join(',')
          if (choiced.indexOf(choiceStr) > -1) {
            valid = false
            console.log('not valid ')
          } else {
            if (choiceStr.length) {
              choiced.push(choiceStr)
            }
          }
        })
        console.log('choiced', choiced)
        return valid
      } else {
        return true
      }
    },

    validateOptions() {
      let valid = true
      if (!this.product.options) {
        return true
      }
      for (let x = 0; x < this.product.options.length; x++) {
        if (!this.product.options[x].label || !this.product.options[x].label.length) {
          EventBus.$emit('showAlert', 'error', 'Campo título do ' + [x + 1] + 'º complemento é obrigatório')
          valid = false
          break
        }
        if (this.product.options[x].min < 0) {
          EventBus.$emit('showAlert', 'error', 'Campo mínimo do ' + [x + 1] + 'º complemento deve ser maior ou igual a 0')
          valid = false
          break
        }
        if (this.product.options[x].max < 1) {
          EventBus.$emit('showAlert', 'error', 'Campo máximo do ' + [x + 1] + 'º complemento deve ser maior que 0')
          valid = false
          break
        }
        if (this.product.options[x].max < this.product.options[x].min) {
          EventBus.$emit('showAlert', 'error', 'Campo máximo do ' + [x + 1] + 'º deve ser maior ou igual ao mínimo')
          valid = false
          break
        }
        valid = this.validateChoices(this.product.options[x].choices, this.product.options[x].active, x)
        if (!valid) {
          break
        }
      }
      return valid
    }
  }
}
